import { Typography } from "@mui/material";
import { makeStyles, useTheme } from "@mui/styles";
import { AddCircle } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { selectUser } from "../reducers/userSlice";


const useStyles = makeStyles(theme => ({
  root: {
    border: 0,
    overflowY: 'hidden',
    padding: 0,
    margin: 0,
    width: '100%',
    height: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  icon: {
    color: theme.palette.grey[500],
    fontSize: '128px',
    marginBottom: 20
  },
  text: {
    color: theme.palette.grey[500],
    fontSize: '24px',
    marginBottom: 80
  },
}));

export const EmptyEconomics = () => {

  const classes = useStyles();
  const theme = useTheme();

  const user = useSelector(selectUser);

  const darkMode = user?.value?.darkMode;


  try {
    return (
      <div className={classes.root} id="empty-fba" style={{backgroundColor: theme?.palette?.paper?.[darkMode ? 'dark' : 'light']}}>
        
        <AddCircle className={classes.icon} />

        <Typography className={classes.text}>
          Load or create analysis to get started
        </Typography>

      </div>
    );

  } catch (error) {
    console.log(error);
    return (<div style={{width: '100%'}}></div>);
  };
};
